/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh>): BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh {
        let obj = Object.assign(new BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh(), model);
        BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh>): BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh {
        if (!model) return null;
        return BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.newInstance(<BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh) {
        if (!obj) return;

        models.BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.backfill_start_date === "string") {
            this.backfill_start_date = new Date(<string><any>this.backfill_start_date);
        }
        if (typeof this.backfill_end_date === "string") {
            this.backfill_end_date = new Date(<string><any>this.backfill_end_date);
        }
        if (this.progress) {
            models.CostProcessingProgress.fixupPrototype(this.progress);
        }
    }

    /**
     * Target Kubernetes Cluster Account under the parent account
     */
    service_account_id: string;

    backfill_start_date: Date;

    backfill_end_date: Date;

    /**
     * Progress of the cost processing
     */
    progress: models.CostProcessingProgress;

}
